import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(legacy)/programs/$programId")({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/creators/programs/$programId/direct",
      params: { programId: params.programId },
      search,
      replace: true,
    });
  },
});
